export const INQUIRY_SCOPE_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'all', label: 'All' },
];

export const INQUIRY_SORT_OPTIONS = [
  { value: 'createdAt', label: 'Date', defaultOrder: -1 },
  { value: 'parentFullName', label: 'Parent', defaultOrder: 1 },
  { value: 'petName', label: 'Pet', defaultOrder: 1 },
];

export const PROFILE_INQUIRY_SORT_OPTIONS = [
  { value: 'createdAt', label: 'Date', defaultOrder: -1 },
  { value: 'petName', label: 'Pet', defaultOrder: 1 },
  { value: 'topicTitle', label: 'Topic', defaultOrder: 1 },
];

export function getProfileInquirySortOptions({ petId } = {}) {
  if (petId) {
    return PROFILE_INQUIRY_SORT_OPTIONS.filter(
      (option) => option.value !== 'petName',
    );
  }
  return PROFILE_INQUIRY_SORT_OPTIONS;
}

export const INQUIRY_DATE_SHORTCUTS = [
  { value: 'today', label: 'Today' },
  { value: 'last 7 days', label: '7d' },
  { value: 'last 30 days', label: '30d' },
];

export const INQUIRY_FILTER_SEARCH_THRESHOLD = 8;

export function getInquiryFilterCategories({
  topics = [],
  doctors = [],
  includeDoctor = true,
}) {
  const topicTitles = [
    ...new Set(
      topics
        .map((topic) => topic?.title)
        .filter((title) => !!title),
    ),
  ].sort();

  const categories = [
    {
      key: 'topicTitle',
      label: 'Topic',
      choices: topicTitles.map((title) => ({
        value: title,
        label: title,
      })),
    },
  ];

  if (!includeDoctor) {
    return categories;
  }

  const doctorChoices = doctors.map((doctor) => ({
    value: doctor._id,
    label: `Dr. ${doctor.name}`,
  }));
  doctorChoices.push({ value: 'NA', label: 'N/A' });

  categories.push({
    key: 'doctorId',
    label: 'Doctor',
    choices: doctorChoices,
  });

  return categories;
}
